var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 15",
    style: {
      enableBackground: "new 0 0 22 15"
    },
    xmlSpace: "preserve",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MDI_eye",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_eye",
    d: "M11,4.5c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S12.7,4.5,11,4.5 M11,12.5c-2.8,0-5-2.2-5-5s2.2-5,5-5 s5,2.2,5,5S13.8,12.5,11,12.5 M11,0C6.1,0,1.8,3,0,7.5c2.4,6.1,9.2,9.1,15.3,6.7c3.1-1.2,5.5-3.6,6.7-6.7C20.2,3,15.9,0,11,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.0971369f52edd3cd2a2c8fc5c4415c9d.svg";
export { ForwardRef as ReactComponent };